<script>
  export let question;
  export let numQuestion;
  export let onAnswer;
  export let selected;
  export let error;

  import Answer from "./Answer.svelte";
</script>

<div class="formquestionsection" id={"q" + numQuestion}>
  <div class="formquestion">
    <div class="formquestionnumber">{numQuestion}</div>
    <div class="formquestiontitle {error ? 'error' : ''}">
      {question.pregunta}
    </div>
  </div>
  <div class="formquestionrating">
    {#each question.respuestas as answer, index}
      <Answer
        {answer}
        lastItem={index === question.respuestas.length - 1}
        onAnswer={() => onAnswer(numQuestion - 1, answer.respuesta)}
        {selected}
      />
    {/each}
  </div>
</div>

<style>
  div.error {
    color: red;
  }
</style>
